import './page.scss';
import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const Rules = () => {
  const { id } = useParams();
  useEffect(() => {
    const el = document.querySelector('.navbar');
    if (el) el.scrollIntoView({ behavior: 'auto' });
  }, [id]);

  return (
    <>
      <Helmet>
        <title>Terms and сonditions – Naijads.ng</title>
        <meta
          name="description"
          content="Review the official Naijads.ng user terms and rules for accessing and using the free classifieds platform across Nigeria."
        />
        <link rel="canonical" href="https://naijads.ng/rules" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'TermsOfService',
            name: 'Terms of Use – Naijads.ng',
            url: 'https://naijads.ng/rules',
            description:
              'Learn the official rules and user conditions for using Naijads.ng to buy, sell, or advertise services across Nigeria.',
            publisher: {
              '@type': 'Organization',
              name: 'Naijads.ng',
              url: 'https://naijads.ng',
              logo: {
                '@type': 'ImageObject',
                url: 'https://naijads.ng/assets/Tayo.svg',
              },
            },
          })}
        </script>
      </Helmet>

      <div className="info-page">
        <div className="info-block-main">
          <h1>Terms and conditions</h1>
          <p>
            Welcome to <strong>Naijads.ng</strong> — Nigeria’s trusted online classifieds platform. By accessing our website, mobile app, or services, you agree to comply
            with these terms and all related policies including our <a href="/privacy-policy">Privacy Policy</a>, <a href="/advertisers">Posting Rules</a>, and other published
            guidelines.
          </p>
        </div>

        <div className="info-block">
          <h3>User account</h3>
          <p>
            You must register with a valid phone number or email to post ads or contact sellers. You are responsible for your account security, and Naijads.ng will not be
            liable for misuse due to weak passwords or unauthorized access.
          </p>
        </div>

        <div className="info-block">
          <h3>Proper use of the platform</h3>
          <ul>
            <li>Post truthful and accurate ads in the correct categories</li>
            <li>Do not post fake, illegal or harmful content</li>
            <li>Respect other users and avoid harassment</li>
            <li>Do not use bots or scraping tools on Naijads.ng</li>
            <li>Only list items or services you’re legally allowed to offer</li>
          </ul>
        </div>

        <div className="info-block">
          <h3>Community safety</h3>
          <p>
            Please report suspicious or harmful ads using the flag icon. Naijads.ng may limit or block accounts that violate rules or threaten community trust. We aim to
            keep Naijads clean, safe, and user-friendly for everyone.
          </p>
        </div>

        <div className="info-block">
          <h3>Fees and services</h3>
          <p>
            Most ad postings are free. However, premium features like boosted visibility or sponsored ads may come with a fee, quoted in Nigerian Naira (NGN). These fees
            are non-refundable once used. You can review charges before confirming. Naijads.ng reserves the right to update pricing or launch promotional offers.
          </p>
        </div>

        <div className="info-block">
          <h3>Limitations & disclaimers</h3>
          <p>
            Naijads.ng operates on an “as is” basis. We are not responsible for the actions of third-party sellers, buyers, or payment processors. Users are advised to meet
            in secure public places and verify items independently before any transaction.
          </p>
        </div>

        <div className="info-block">
          <h3>Content ownership</h3>
          <p>
            When you post an ad, you give Naijads.ng permission to display and promote your content across our platform and channels. You must not upload materials you do
            not own the rights to, including logos, images, or protected trademarks.
          </p>
        </div>

        <div className="info-block-main">
          <h3>Reporting copyright or trademark Violations</h3>
          <p>
            If you believe your intellectual property has been infringed on Naijads.ng, contact our support team at <a href="mailto:support@naijads.ng">support@naijads.ng</a>{' '}
            with proof of ownership. We take rights seriously and will investigate promptly.
          </p>
        </div>

        <div className="info-block">
          <h3>Legal jurisdiction</h3>
          <p>
            These terms are governed by Nigerian law. Users found violating legal provisions or engaging in fraudulent activity may be reported to appropriate agencies.
          </p>
        </div>

        <div className="info-block">
          <h3>Indemnification</h3>
          <p>
            You agree to indemnify Naijads.ng from any third-party claims resulting from your use of the platform, breach of terms, or unlawful activity through your
            account.
          </p>
        </div>
      </div>
    </>
  );
};

export default Rules;
